import React from 'react';
import { Shield, Star, ChevronDown, ArrowRight, CheckCircle } from 'lucide-react';

interface HeroSectionProps {
  onCtaClick: () => void;
}

const TRUST_BADGES = [
  { label: '4.9/5 Rating', icon: Star },
  { label: '4,200+ Reviews', icon: CheckCircle },
  { label: '2025/26 Ready', icon: Shield },
  { label: 'GDPR Compliant', icon: Shield },
];

export function HeroSection({ onCtaClick }: HeroSectionProps) {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1920&q=80&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/95 via-gray-900/85 to-gray-900/95" />
        <div className="absolute inset-0 bg-grid-pattern opacity-10" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className="animate-fade-in-up">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" />
            <span className="text-white/90 text-sm font-medium">Renters Rights Bill 2025 &mdash; Fully Integrated</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
            Tenancy Agreement
            <br />
            <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
              Review & Re-Write
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-10">
            AI-powered clause-by-clause analysis against the latest UK legislation.
            Fully rewritten agreement delivered in under 5 minutes.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={onCtaClick}
              className="group relative bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold text-base hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <span className="inline-flex items-center gap-2">
                Get Your Review &mdash; &pound;15.50
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
            <span className="text-gray-400 text-sm">Results in under 5 minutes</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {TRUST_BADGES.map((badge) => (
              <div key={badge.label} className="flex items-center gap-2 text-white/70">
                <badge.icon className="w-4 h-4" />
                <span className="text-sm font-medium">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce-down">
        <ChevronDown className="w-6 h-6 text-white/40" />
      </div>
    </section>
  );
}
